import React, { createContext, useMemo, useState } from 'react';

interface CurrentPathContextData {
    currentPath: string;
    activeTab: string
    setCurrentPath: (value: string) => void;
    setActiveTab: (value: string) => void;
}

export const CurrentPathContext = createContext<CurrentPathContextData>({
    currentPath: "",
    activeTab: "",
    setCurrentPath: () => { },
    setActiveTab: () => { }
});

export const CurrentPathProvider: React.FC<{ children: React.ReactNode }> = ({
    children,
}) => {
    const [currentPath, setCurrentPath] = useState<string>("");
    const [activeTab, setActiveTab] = useState<string>("");

    const value = useMemo(() => ({ currentPath, activeTab, setCurrentPath, setActiveTab }), [currentPath, activeTab]);

    return (
        <CurrentPathContext.Provider value={value}>
            {children}
        </CurrentPathContext.Provider>
    );
};
